export default {
  getLocalityString: props => {
    const { city, province, postal_code } = props;
    return `${city ? `${city}, ` : ''}${province
      ? `${province} `
      // eslint-disable-next-line camelcase
      : ''}${postal_code ? `${postal_code}` : ''}`;
  }
};



// WEBPACK FOOTER //
// ./webpack/lib/utils/location.js